import httpManager from "../../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function fetchCustomerPersonalField(id) {
  const url = `/contacts/clients/${id}/general-fields/`;
  const response = await httpManager.get(url);

  return response.data;
}
